import {DsLoadingAreaConfiguration, DsLoadingAreaService, DsTableModule,} from '@bmw-ds/components';
import {ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CriteriaResponse} from '../../models/criteria.model';
import {CriteriaService} from '../../services/criteria.service';
import {CriteriaStoreService} from '../../services/criteria-store.service';
import {ReplenishmentRequest} from '../../models/replenishment-request.model';
import {BreadcrumbComponent} from '../../components/breadcrumb/breadcrumb.component';
import {ReplenishmentStockFiltersComponent} from '../../components/replenishment-stock-filters/replenishment-stock-filters.component';
import {AuthService} from '../../services/auth.service';
import {take} from 'rxjs';

@Component({
    selector: 'app-replenishment-stock',
    imports: [
        DsTableModule,
        CommonModule,
        BreadcrumbComponent,
        ReplenishmentStockFiltersComponent,
    ],
    templateUrl: './replenishment-stock.component.html',
    styleUrl: './replenishment-stock.component.scss',
    standalone: true,
})
export class ReplenishmentStockComponent implements OnInit {
    filters: ReplenishmentRequest = {
        plant: '',
        model: '',
        brandName: '',
        brand: '',
        storageLocation: '',
        version: {
            brand: '',
            vehicleType: '',
            version: '',
        },
        materialNr: [],
    };

    loadingAreaConfig: DsLoadingAreaConfiguration = {id: 'bodyLoading'};
    criteriaData!: CriteriaResponse;

    private readonly loadingAreaService = inject(DsLoadingAreaService);
    private readonly criteriaService = inject(CriteriaService);
    private readonly criteriaStoreService = inject(CriteriaStoreService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly authService = inject(AuthService);

    ngOnInit(): void {
        this.authService.isAuthenticated().pipe(take(1)).subscribe((isAuthenticated) => {
            if (isAuthenticated) {
                this.loadCriteriaData(localStorage.getItem('dealerCode') ?? ''); // Default dealer code if not set
            } else {
                window.location.href = this.authService.getAuthUrl(); // Redirect to the auth URL
            }
        });
    }

    loadCriteriaData(dealerCode: string): void {
        this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
        this.criteriaService.postCriteriaSelection(dealerCode).subscribe({
            next: (data: CriteriaResponse) => {
                this.criteriaData = data;
                this.cdr.detectChanges();
                this.criteriaStoreService.setCriteriaData(data);
                this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
            },
            error: (error: unknown) => {
                this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
                console.error('Error fetching criteria data', error);
            },
        });
    }
}
